// import one from "../assets/svg/projects/one.svg";
// import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
import eight from "../assets/svg/projects/eight.svg";
export const projectsData = [
  {
    id: 1,
    projectName: "Mobilne USG",
    projectDesc:
      "Świadoma znaczenia diagnostyki i pragnąc zapewnić wsparcie wykraczające poza sam opis wyników, współtworzę projekt wizyt w studiach personalnych, klubach walki i boxach CF, gdzie badamy klubowiczów.",
    tags: ["Świadomość", "Troska", "Zdrowie"],
    code: "",
    demo: "",
    image: eight,
  },
  {
    id: 2,
    projectName: "Warsztaty dotyczące regeneracji",
    projectDesc:
      "Uczestnicy pogłębili swoją wiedzę na temat zmęczenia, przetrenowania, metod regeneracji, istoty efektywnego snu oraz 10 zasad regeneracji.",
    tags: ["Zmęczenie", "Przetrenowanie", "Regeneracja"],
    code: "",
    demo: "",
    image: four,
  },
  {
    id: 3,
    projectName: "Szkolenie o bólu",
    projectDesc:
      "Podczas szkolenia trenerzy poznali naturę bólu, mechanizmy jego powstawania i czynniki odpowiedzialne. Nauczono ich także opracowywania programów treningowych dla osób zmagających się z bólem.",
    tags: ["Ból", "Programy treningowe", "Trenerzy"],
    code: "",
    demo: "",
    image: three,
  },
  {
    id: 4,
    projectName: "Prywatne szkolenie",
    projectDesc:
      "Jesteś zainteresowany konkretnym tematem? Chcesz mieć pewność zdobycia umiejętności? Potrzebujesz wykwalifikowanego specjalisty. Szkolenia skrojone na miarę to kolejny projekt, w którym się realizuję.",
    tags: ["Szkolenie", "Tematy", "Umiejętności"],
    code: "",
    demo: "",
    image: seven,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
